import {
    ActionIcon,
    Anchor,
    Box,
    Button,
    createStyles,
    Divider,
    Group,
    Input,
    Modal,
    NativeSelect,
    NumberInput,
    Pagination,
    Paper,
    Popover,
    ScrollArea,
    SegmentedControl,
    Skeleton,
    Table,
    Text,
} from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconFileSymlink, IconPalette, IconPlus, IconSearch, IconTrash, IconX } from '@tabler/icons-react';
import { ListViewOption } from 'core/components/listToggle/listToggleControl';
import { selectSample, selectSamples } from 'modules/Warehouse/warehouseSlice';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FilterButton, FormInputWrapper } from 'core/components';
import { logger } from 'utils/logger';
import { AppConstants, SeasonActions, SessionActions, SETTINGS, ViewModes } from 'utils/constants';
import { IconChevronRight } from '@tabler/icons-react';
import SampleEdit from 'modules/Warehouse/features/sample/SampleEdit';
import SamplesUpload from 'modules/Warehouse/features/samples/SamplesUpload';
import {
    createSession,
    fetchSeasonDocuments,
    fetchSeasonDocumentsSuccess,
    fetchSeasonStyles,
    getSeasonSuccess,
    importMastersStyles,
    importMastersStylesToSeasonSuccess,
    removeStylesFromSeason,
    setDisplayPrefs,
    setSeasonDocumentFilters,
    updateSeasonStyle,
    uploadPDFToSeasonSuccess,
} from 'modules/Seasons/seasonSlice';
import { closeAllModals, openConfirmModal, openModal } from '@mantine/modals';
import { EmptyState } from 'core/components/emptyState/EmptyState';
import { SampleEventType } from 'core/models/SampleModel';
import { SeasonEventType } from 'core/models/SeasonModel';
import SessionEdit from 'modules/Sessions/features/session/SessionEdit';
import { selectSession } from 'modules/Sessions/sessionSlice';
import { SessionModel } from 'core/models';
import { matchesKeywords, selectItems } from 'utils/helper';
import AssignToSession from './AssignToSession';
import { showNotification } from '@mantine/notifications';
import StyleEdit from 'modules/Styles/features/style/StyleEdit';
import { useAbortController } from 'core/hooks/useAbortableController';
import { useLocalStorage } from '@mantine/hooks';
import { DocumentFilterModel } from 'core/models/DocumentFilterModel';
import BatchSeasonStyleEdit from './BatchSeasonStyleEdit';
import MastersStyleImport from './MastersStyleImport';

import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import { DocumentEventType, SeasonDocumentModel } from 'core/models/SeasonDocumentModel';
import DocumentViewer from 'core/components/documentViewer/DocumentViewer';
import { useForm } from '@mantine/form';

const useStyles = createStyles((theme, _params, getRef) => ({
    displayFooter: {
        position: 'fixed',
        bottom: 0,
        background: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
        right: theme.spacing.lg,
        left: 240,
        borderTop: '1px solid',
        borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[3],
    },
}));

const SeasonTabDocuments = ({ user, season, selectedSamples, success, error, onStatusClick, aggData, documentFilters, setDocumentFilters, displayPrefs, setDisplayPrefs, onAction }) => {
    const dispatch = useDispatch();
    // const [items, setItems] = useState(selectedItems);
    const [data, setData] = useState(season?.documents || []);

    const { classes, cx } = useStyles();
    const [filterOpen, setFilterOpen] = useState(false);
    const [listView, setListView] = useState(ListViewOption.LIST);
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedItems, setSelectedItems] = useState(selectedSamples);
    const [filterCount, setFilterCount] = useState(0);

    // const [documentFilter, setSampleFilter] = useState({ ...SampleFilterModel });
    const [filterItems, setFilterItems] = useState(null);
    const [sampleModalOpen, setSampleModalOpen] = useState(false);
    const [sampleImportModalOpen, setSampleImportModalOpen] = useState(false);
    const [sampleUploadShown, setSampleUploadShown] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // const [columns, setColumns] = useState([...defaultColumns]);
    const [columns, setColumns] = useState([
        {
            // Build our expander column
            id: 'expander', // Make sure it has an ID
            Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
                <>
                    {/* <span {...getToggleAllRowsExpandedProps()}>
        {isAllRowsExpanded ? <IconChevronDown /> : <IconChevronRight />}
        </span> */}
                </>
            ),
            Cell: ({ row }) =>
                // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
                // to build the toggle for expanding a row
                row.canExpand ? (
                    <span
                        {...row.getToggleRowExpandedProps({
                            style: {
                                // We can even use the row.depth property
                                // and paddingLeft to indicate the depth
                                // of the row
                                paddingLeft: `${row.depth * 2}rem`,
                            },
                        })}>
                        {row.isExpanded ? <IconChevronDown /> : <IconChevronRight />}
                    </span>
                ) : null,
        },

        // Document columns
        {
            Header: 'Document Name',
            accessor: 'documentName',
            sortType: 'alphanumeric',
            width: 250,
            show: true,
            Cell: ({ value, row }) => {
                return (
                    <Anchor
                        className='router-link'
                        size='sm'
                        onClick={(e) => {
                            e.preventDefault();
                            console.log('📋 Document cell clicked:', row.original);
                            onDocumentAction(DocumentEventType.DOCUMENT_VIEW, row.original);
                        }}
                        style={{ cursor: 'pointer' }}>
                        <Text size='sm' style={{ wordBreak: 'break-word' }}>
                            {value}
                        </Text>
                    </Anchor>
                );
            },
        },
        // {
        //     Header: 'Bucket',
        //     accessor: 'bucket',
        //     sortType: 'alphanumeric',
        //     width: 150,
        //     show: true,
        // },
        // {
        //     Header: 'Operator',
        //     accessor: 'operator',
        //     sortType: 'alphanumeric',
        //     width: 120,
        //     show: true,
        // },
        {
            Header: 'Pages',
            accessor: 'pageCount',
            sortType: 'numeric',
            width: 80,
            show: true,
            Cell: ({ value }) => (
                <Text size='sm' align='center'>
                    {value}
                </Text>
            ),
        },
        {
            Header: 'Product Suggestions',
            accessor: 'pageProductSuggestions',
            sortType: 'alphanumeric',
            headerStyle: { textAlign: 'center' },
            width: 120,
            show: true,
            Cell: ({ value }) => {
                if (!value) return '-';
                // get the total number of products
                const totalProducts = Object.keys(value).reduce((acc, page) => acc + value[page].length, 0);
                // const pagesWithSuggestions = Object.keys(value).filter((page) => value[page] && value[page].length > 0).length;
                return (
                    <Text size='sm' align='center'>
                        {totalProducts}
                    </Text>
                );
            },
        },
        {
            Header: 'Season Part',
            accessor: 'seasonPart',
            sortType: 'alphanumeric',
            width: 150,
            show: true,
        },
        // {
        //     Header: 'Upload Date',
        //     accessor: 'seasonSort',
        //     sortType: 'datetime',
        //     width: 150,
        //     show: true,
        //     Cell: ({ value }) => {
        //         if (!value) return '-';
        //         try {
        //             const date = new Date(value);
        //             return date.toLocaleDateString();
        //         } catch {
        //             return value;
        //         }
        //     },
        // },
        // {
        //     Header: 'Actions',
        //     accessor: 'actions',
        //     sortType: 'alphanumeric',
        //     width: 150,
        //     show: true,
        //     Cell: ({ row }) => (
        //         <Menu shadow='md' width={200} withinPortal={true}>
        //             <Menu.Target>
        //                 <ActionIcon size='sm' variant='subtle' color='blue' title='Document Actions'>
        //                     <IconChevronDown size={16} />
        //                 </ActionIcon>
        //             </Menu.Target>
        //             <Menu.Dropdown>
        //                 <Menu.Item icon={<IconFileSymlink size={14} />} onClick={() => handleDocumentView(row.original)}>
        //                     View Document
        //                 </Menu.Item>
        //                 <Menu.Item icon={<IconDatabaseImport size={14} />} onClick={() => handleDocumentDownload(row.original)}>
        //                     Download
        //                 </Menu.Item>
        //                 <Menu.Item icon={<IconPalette size={14} />} onClick={() => handleDocumentEdit(row.original)}>
        //                     Edit
        //                 </Menu.Item>
        //                 <Menu.Divider />
        //                 <Menu.Item icon={<IconTrash size={14} />} color='red' onClick={() => handleDocumentDelete(row.original)}>
        //                     Delete
        //                 </Menu.Item>
        //             </Menu.Dropdown>
        //         </Menu>
        //     ),
        // },
    ]);
    const params = useParams();
    const [scrolled, setScrolled] = useState(false);

    const abortController = useAbortController();

    // const columns = defaultColumns;
    const [hiddenColumns, setHiddenColumns] = useLocalStorage({
        key: 'oi-season-documents-hidden-columns',
        defaultValue: [...columns].filter((val) => Object.hasOwn(val, 'show') && val.show === false && val.accessor).map((val) => val.accessor),
    });

    const documentFilter = useMemo(() => {
        return documentFilters[params.id] ? documentFilters[params.id].filter : { ...new DocumentFilterModel() };
    }, [season, documentFilters]);

    const setDocumentFilter = useCallback(
        (filter) => {
            dispatch(setDocumentFilters({ seasonId: params.id, filter }));
        },
        [season, documentFilters, documentFilter],
    );

    useEffect(() => {
        setData(season?.documents || []);
    }, [season]);

    useEffect(() => {
        logger.log('location', location);
        // how to get search params
        const searchParams = new URLSearchParams(location.search);
        const documentId = searchParams.get('documentId');
        if (documentId && season?.documents) {
            const document = season?.documents.find((doc) => doc.seasonSort === documentId || doc.id === documentId);
            if (document) {
                openDocumentViewer(document);
            }
            // onDocumentAction(DocumentEventType.DOCUMENT_VIEW, documentId);
        }
    }, [location, season?.documents]);

    // updat the columns with company specific columns on the aggData Update
    // useEffect(() => {
    //     var tmpCols = [
    //         ...columns,
    //     ];

    //     logger.log(' COLUMNS:', tmpCols, getCompany(aggData)?.code);
    //     setColumns([...tmpCols]);
    // }, [aggData]);

    const {
        getTableProps,
        // getTableBodyProps,
        headerGroups,

        prepareRow,
        page, // Instead of using 'rows', we'll use page,
        // which has only the rows for the active page
        rows,
        // The rest of these things are super handy, too ;)
        // canPreviousPage,
        // canNextPage,
        pageOptions,
        // pageCount,
        gotoPage,
        // nextPage,
        // previousPage,

        setPageSize,
        state: { pageIndex, pageSize },
        // preGlobalFilteredRows,
        // setGlobalFilter
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: AppConstants.defaultPaginationSize, globalFilter: null, hiddenColumns: [...hiddenColumns] },
        },

        useFilters,
        useGlobalFilter, // useGlobalFilter!
        useSortBy,
        usePagination,
    );

    const [currentConfig, setCurrentConfig] = useState('full');
    const [currentPage, setCurrentPage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePageChange = (page, index, document) => {
        setCurrentPage(page);
        setCurrentIndex(index);
        console.log('Page changed:', page, 'Index:', index, 'Document:', document);
    };

    const configurations = {
        full: {
            showThumbnails: true,
            showMetadata: true,
            maxHeight: '700px',
        },
        previewOnly: {
            showThumbnails: false,
            showMetadata: false,
            maxHeight: '600px',
        },
        noMetadata: {
            showThumbnails: true,
            showMetadata: false,
            maxHeight: '650px',
        },
        noThumbnails: {
            showThumbnails: false,
            showMetadata: true,
            maxHeight: '650px',
        },
    };

    const selectAllMenu = (
        <div>
            {/* <Button variant='default' onClick={(e) => onMenuItemClick(e)}>Create new Season</Button>
      <Button variant='default' onClick={(e) => onMenuItemClick(e)}>Add to Season</Button> */}
            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.CREATE_SESSION })}>
                Create Session
            </Button>

            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.SEASON_ASSIGN_STYLES_TO_SESSION })}>
                Assign to Session
            </Button>

            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.REMOVE_SAMPLE, data: selectedItems })}>
                Remove from Event
            </Button>

            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.SEASON_BATCH_EDIT_STYLES, data: selectedItems })}>
                Batch Update Styles
            </Button>

            <Button variant='default' onClick={(e) => onSelectAll(e)}>
                Deselect All
            </Button>
        </div>
    );

    const filterDocuments = useCallback(() => {
        var data = season?.documents?.filter((sample) => {
            var match = true;

            const totalProducts = Object.keys(sample.pageProductSuggestions).reduce((acc, page) => acc + sample.pageProductSuggestions[page].length, 0);

            if (documentFilter.hasProducts === '1' && match) {
                match = totalProducts > 0 ? true : false;
                // logger.log(match);
            } else if (documentFilter.hasProducts === '0' && match) {
                match = totalProducts === 0 ? true : false;
            }

            // page count filter
            if (documentFilter.pageRange.pageStart && documentFilter.pageRange.pageEnd && match) {
                match = sample.pageCount >= documentFilter.pageRange.pageStart && sample.pageCount <= documentFilter.pageRange.pageEnd ? true : false;
            }

            if (sample && documentFilter.keyword && documentFilter.keyword.length && match) {
                match = matchesKeywords(
                    documentFilter.keyword,
                    sample.documentName,
                    sample.seasonSort,
                    sample.seasonPart,
                    sample.pageTexts ? Object.values(sample.pageTexts).join(' ') : '',
                    sample.pageProductSuggestions ? Object.values(sample.pageProductSuggestions).join(' ') : '',
                );
            }

            return match;
        });

        if (documentFilter.groupBy) {
            var uniq = [...new Set(Object.keys(data).map((e) => data[e][documentFilter.groupBy]))];
            // create the group by items
            var groupedData = uniq.map((group) => {
                var subRows = data.filter((val) => val[documentFilter.groupBy] === group);
                return { type: 'group', name: group, subRows, id: group };
            });
            data = groupedData;
        }

        if (data) setData(data);
    }, [documentFilter.hasProducts, documentFilter.pageRange, setData, season, documentFilter.groupBy, documentFilter.keyword]);

    // Request handler hide preloading
    useEffect(() => {
        logger.log('success', success);
        if (success) {
            switch (success.type) {
                case importMastersStylesToSeasonSuccess.toString(): {
                    openConfirmModal({
                        title: 'Styles imported',
                        children: <Text size='sm'>Your styles have been successfully imported would you like to view the styles now?</Text>,
                        labels: {
                            confirm: 'Yes, view Styles now',
                            cancel: 'Cancel',
                        },
                        onConfirm: () => setSampleImportModalOpen(false),
                    });
                    dispatch(fetchSeasonStyles(params.id, null, abortController.current.signal));

                    break;
                }

                case fetchSeasonDocumentsSuccess.toString(): {
                    setIsLoading(false);
                    filterDocuments();

                    break;
                }
                case getSeasonSuccess.toString(): {
                    logger.log('getSeasonSuccess', params);
                    // dispatch(fetchSeasonStyles(params.id, null, abortController.current.signal));
                    dispatch(fetchSeasonDocuments({ id: params.id }, null, abortController.current.signal));
                    break;
                }
                case uploadPDFToSeasonSuccess.toString(): {
                    setTimeout(() => {
                        dispatch(fetchSeasonDocuments({ id: params.id }, null, abortController.current.signal));
                    }, 5000);
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }, [success]);

    /**
     * Handles the list toggle display
     * @param {*} val
     */
    // const listToggleHandler = (val) => {
    //     navigate({ search: `?displayType=${val}` });
    // };

    /**
     * Effect to fetch the samples
     */
    // useEffect(() => {
    //     if ((!hasInit.current && season && season.id) || (season && season.id !== params.id)) {
    //         setTimeout(() => {
    //             dispatch(fetchSeasonStyles(params.id, user));
    //         }, 100);
    //         hasInit.current = true;
    //     }
    // }, [dispatch, hasInit, season, params.id, user]);

    // useEffect(() => {
    //     //setSampleData(samples);

    //     // set the brands/season/category
    //     var brands = {};
    //     var categories = {};
    //     var seasons = {};
    //     var sampleSize = {};
    //     var shotStyle = {};
    //     var department = {};
    //     var sessions = {};
    //     var photoCode = {};

    //     season?.documents?.forEach((item, idx) => {
    //         brands[item.facet_brand] = item;
    //         categories[item.metadata_toplevelcategory] = item;
    //         seasons[item.facet_season] = item;
    //         if (item.instructions) {
    //             sampleSize[item.instructions['Web Photography Sample Size'] ?? ''] = item;
    //             shotStyle[item.instructions['Web Photography Style']] = item;
    //             department[item.instructions['departmentStr']] = item;

    //             if (item.studioSessionCodes) {
    //                 const sessionCodes = item.studioSessionCodes;
    //                 sessionCodes.forEach((code) => {
    //                     sessions[code.trim()] = item;
    //                 });
    //             }

    //             photoCode[item.instructions['Web Photography Code']] = item;
    //         }
    //     });

    //     setFilterItems({ brands, categories, seasons, sampleSize, shotStyle, department, sessions, photoCode });

    //     filterDocuments();
    // }, [season?.documents, filterDocuments]);

    /**
     * Effect to handle location change
     */
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        let displayType = params.get('displayType');
        logger.log('location change ', location, ' DISPLAY: ', displayType, params);
        // if display type changes
        if (displayType && displayType !== listView) setListView(displayType);
    }, [location, listView]);

    const onItemClick = (item) => {
        // we need to select the current sample
        // dispatch(selectSample(item));
        // openSampleDetail(item);
        // update the route
        // navigate(`/warehouse/samples/${item.stylenumber}`);
        // dispatch(selectSample(item));

        // openSampleDetail(item);
        // update the route
        // navigate(`/warehouse/feed/${item.stylenumber}`);

        // changed to show modal so we allow for photoCode edit
        // navigate(`/warehouse/styles/${item.seasonSort}`);

        // TODO ADD THIS BACK IN
        openStyleModal(item);
    };

    const onItemSelected = (e, item, selected, rows) => {
        var items = [...selectedItems];
        selectItems(
            e,
            item,
            selected,
            rows.map((val) => val.original),
            items,
        );
        // if the item is a group then push the elements into the group.
        // if (item.type && item.type === 'group') {
        //     if (selected) {
        //         items.push({ id: item.id });
        //         item.subRows.forEach((row) => {
        //             var tmpItem = items.find((val) => val.id === row.id);
        //             if (!tmpItem) items.push({ id: row.id });
        //         });
        //     } else {
        //         _.remove(items, (val) => {
        //             return val.id === item.id;
        //         });

        //         item.subRows.forEach((row) => {
        //             _.remove(items, (val) => {
        //                 return val.id === row.id;
        //             });
        //         });
        //     }
        // } else {
        //     if (selected) {
        //         if (!items.find((val) => item.id === val.id))
        //             items.push({ id: item.id });
        //     } else {
        //         _.remove(items, (val) => {
        //             return val.id === item.id;
        //         });
        //     }
        // }

        // selectSamples(items);
        setSelectedItems(items);
    };

    const onSelectAll = () => {
        // if there are items selected remove them
        if (selectedItems.length) {
            setSelectedItems([]);
            // dispatch(selectSamples([]));
        } else {
            setSelectedItems([...data]);
            // dispatch(selectSamples([...data]));
        }
    };

    const onMenuItemClick = (e) => {
        logger.log(e);
        switch (e.type) {
            case SeasonEventType.CREATE_SESSION: {
                openSessionModal();
                break;
            }
            case SeasonEventType.SEASON_ASSIGN_STYLES_TO_SESSION: {
                openAssignToSessionModal();
                break;
            }

            case SampleEventType.SAMPLE_ASSIGN_CAPTURES: {
                onItemClick(e.data);
                break;
            }

            case SampleEventType.SAMPLE_BUILD_OUTFIT: {
                navigate(`/warehouse/outfitter/create`);
                break;
            }

            case SampleEventType.SAMPLE_SHOW_SESSION: {
                navigate(`/sessions/${e.data}`);
                break;
            }

            case SampleEventType.SAMPLE_DELETE:
            case SeasonActions.REMOVE_SAMPLE: {
                openConfirmModal({
                    title: 'Style remove confirm',
                    children: (
                        <>
                            <Text size='sm'>Are you sure you want to remove the styles from this Event</Text>
                        </>
                    ),
                    labels: { confirm: 'Confirm', cancel: 'Cancel' },
                    onCancel: () => console.log('Cancel'),
                    onConfirm: () => {
                        var items = [];
                        var missCount = [];
                        e.data.forEach((val) => {
                            const tmpStyle = data.find((item) => item.id === val.id);
                            if (!tmpStyle.studioSessionCodes || (tmpStyle.studioSessionCodes && tmpStyle.studioSessionCodes.length === 0)) {
                                items.push(tmpStyle);
                            } else {
                                missCount.push(val.id);
                            }
                        });

                        if (items.length) {
                            dispatch(removeStylesFromSeason(season, items));
                        }

                        closeAllModals();

                        if (missCount.length) {
                            openConfirmModal({
                                title: 'Unable to remove',
                                children: (
                                    <>
                                        <Text size='sm'>We weren't able to remove the following styles due to them being assigned to existing sessions.</Text>
                                    </>
                                ),
                                labels: { confirm: 'Confirm', cancel: 'Cancel' },
                                onCancel: () => console.log('Cancel'),
                                onConfirm: () => {
                                    closeAllModals();
                                },
                            });
                        }
                    },
                });

                break;
            }

            case SeasonEventType.SEASON_BATCH_EDIT_STYLES: {
                const payload = e.data.map((val) => {
                    const item = season.documents.find((o) => o.id === val.id);
                    return { ...item };
                });

                openModal({
                    title: 'Batch Update Styles',
                    size: 'xl',
                    children: (
                        <>
                            <BatchSeasonStyleEdit mode={ViewModes.EDIT} season={season} styles={payload} onCancel={closeAllModals} user={user} validate={{}} />
                        </>
                    ),
                });
                break;
            }

            case SampleEventType.SAMPLE_VIEW_CAPTURES: {
                navigate(`/warehouse/styles/${e.data.stylenumber}/captures`);
                break;
            }

            default: {
                break;
            }
        }
    };

    const onCreateSessionSubmit = (vals) => {
        logger.log('onCreateSessionSumit', vals);
        var styles = vals.documents.map((val) => {
            const style = season.documents.find((sample) => val === sample.id);

            return {
                ...style,
                channels: vals.channels, // add channels to the style
                targetSort: style.seasonSort,
                name: style.instructions['Name'],
                descr: '',
            };
        });

        logger.log('styles', styles, vals);

        dispatch(createSession({ ...vals, styles: styles }, user, season));
    };

    const openSessionModal = (styleArray) => {
        const data = styleArray ? styleArray : selectedItems;

        const styles = data.map((val, idx) => {
            let item = season.documents.find((style) => style.id === val.id);
            return item;
        });

        logger.log(styles);

        dispatch(selectSession(new SessionModel()));

        openModal({
            title: 'Create a new Session',
            size: 'xl',
            children: (
                <>
                    <SessionEdit
                        styles={styles}
                        availableStyles={season.documents.map((val) => ({ ...val, targetSort: val.seasonSort }))}
                        season={season}
                        onSubmit={onCreateSessionSubmit}
                        onCancel={() => {
                            closeAllModals();
                        }}
                    />
                </>
            ),
        });
    };

    const openAssignToSessionModal = (styleArray) => {
        const data = styleArray ? styleArray : selectedItems;

        const styles = data.map((val, idx) => {
            let item = season.documents.find((style) => style.id === val.id);
            return item;
        });

        logger.log(styles);

        // dispatch(selectSession(new SessionModel()));

        openModal({
            title: 'Assign Styles to Session',
            size: 'lg',
            children: (
                <>
                    <AssignToSession
                        styles={styles}
                        availableStyles={season.documents.map((val) => ({ ...val, targetSort: val.seasonSort }))}
                        season={season}
                        // onSubmit={onCreateSessionSubmit}
                        onCancel={() => {
                            closeAllModals();
                        }}
                    />
                </>
            ),
        });
    };

    const openStyleModal = (item) => {
        dispatch(selectSample(item));

        openModal({
            title: 'Sample Edit',
            size: 'xl',
            children: (
                <>
                    <StyleEdit
                        sample={item}
                        onSubmit={(values) => {
                            // save the style
                            const sample = { ...values, styleCode: values.seasonSort, photoCode: values.photoCode, channels: values.channels.join(',') };
                            dispatch(updateSeasonStyle(season, sample));
                        }}
                        onCancel={() => {
                            closeAllModals();
                        }}
                    />
                </>
            ),
        });
    };

    const setFilterVars = (vals) => {
        logger.log(vals);
        setDocumentFilter({ ...vals, pageIndex: 0 });
    };

    useEffect(() => {
        // filter the data.
        filterDocuments();
    }, [filterDocuments]);

    const getFilterCount = (val) => {
        var count = 0;
        Object.entries(val).forEach(([key, value]) => {
            if (value?.length) {
                ++count;
            }
            if (key === 'status') {
                var statusCount = 0;
                Object.entries(value).forEach(([key, value]) => {
                    logger.log(key, value);
                    if (value && value.length) {
                        ++statusCount;
                    }
                });

                count += statusCount;
            }
            if (key === 'pageRange') {
                if (value.pageStart.toString() || value.pageEnd.toString()) {
                    ++count;
                }
            }
        });

        return count;
    };

    useEffect(() => {
        const count = getFilterCount(documentFilter);
        setFilterCount(count);
    }, [documentFilter]);

    const onClearClick = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopPropagation();
        const filter = new DocumentFilterModel();
        filter.pageRange = { pageStart: '', pageEnd: '' };
        setDocumentFilter(filter);
        logger.log('CLEAR CLICK', e);
    };

    const filterButtonHandler = (e) => {
        logger.log('BUTTON CLICK', e, e.nativeEvent);
        setFilterOpen((o) => !o);
    };

    // const onSampleAction = (e) => {
    //     switch (e.type) {
    //         case SeasonActions.ASSIGN_SAMPLE: {
    //             openSampleAssign();
    //             break;
    //         }
    //     }
    // };

    // const openSampleAssign = () => {
    //     openModal({
    //         title: 'Apply Styles',
    //         size: 'xl',
    //         children: <>{/* <AssignSample season={season} /> */}</>,
    //     });
    // };

    // const openSampleDetail = (sample) => {
    //     openModal({
    //         title: 'Assign Style Captures',
    //         size: '100%',
    //         children: <>{/* <ShotAssign season={season} sample={sample} /> */}</>,
    //     });
    // };

    const rowMenuItems = [
        {
            handler: (data) => {
                openSessionModal([data]);
            },
            label: 'Create Session',
            icon: <IconPlus size={14} />,
        },
        {
            handler: (data) => {
                openAssignToSessionModal([data]);
            },
            label: 'Assign to Session',
            icon: <IconFileSymlink size={14} />,
        },
        {
            handler: (data) => {
                onMenuItemClick({ e: SessionActions.REMOVE_SAMPLE, data: [data] });
            },
            label: 'Unassign',
            icon: <IconTrash size={14} />,
        },
    ];

    const onMastersImport = (action, data) => {
        logger.log('onMastersImport', action, data);

        dispatch(importMastersStyles(season, data));
    };

    const onSampleSave = (action, data) => {
        // refetch the seasons style.
        showNotification({
            title: 'Success',
            message: 'New Style created',
            position: 'top-center',
            color: 'teal',
        });

        // close the modal only if we aren't createing any more
        if (!displayPrefs.createAnotherStyleFlag) {
            setSampleModalOpen(false);
        }

        dispatch(fetchSeasonStyles(season.id, null, abortController.current.signal));
    };

    const columnFilterHandler = (type, data, isShown) => {
        const show = !isShown;
        const idx = hiddenColumns.indexOf(data.accessor);
        var cols = [...hiddenColumns];

        logger.log(cols, data, isShown, idx);
        // if we need to add
        if (!show && idx < 0) {
            cols.push(data.accessor);
        }

        if (!show && idx > -1) {
            cols.splice(idx, 1);
        }

        if (show && idx > -1) {
            cols.splice(idx, 1);
        }
        logger.log(' AFTER SPLCE', cols, data, isShown);
        setHiddenColumns([...cols]);
    };

    const onPrefChange = (val) => {
        logger.log(val);
        setDisplayPrefs({ createAnotherStyleFlag: val });
    };

    const onDocumentAction = (action, data) => {
        console.log('🔍 onDocumentAction called with:', { action, data, searchParams: searchParams.toString() });
        logger.log('onDocumentAction called with:', { action, data, searchParams: searchParams.toString() });

        // Handle case where data is just a string (documentId) from URL params
        let document = data;
        let documentId = data;

        if (typeof data === 'string') {
            // Find the document by ID in the current data
            document = season?.documents?.find((doc) => doc.seasonSort === data || doc.id === data);
            documentId = data;
            logger.log('String data - found document:', document);
        } else {
            // data is a document object
            documentId = data.seasonSort || data.id;
            logger.log('Object data - documentId:', documentId);
        }

        if (!document) {
            logger.error('Document not found:', data);
            return;
        }

        // Update URL params using navigate instead of setSearchParams
        const newParams = new URLSearchParams(searchParams);
        newParams.set('documentId', documentId);

        setSearchParams(newParams);

        // Open modal with the document viewer
        // openDocumentViewer(document);
    };

    const openDocumentViewer = (document) => {
        const pageStyleSuggestions = {};
        if (document?.pageProductSuggestions && season?.styles) {
            Object.keys(document.pageProductSuggestions).forEach((pageIdx) => {
                const productIds = document.pageProductSuggestions[pageIdx];
                const tmpStyleSuggestions = productIds
                    .map((id) => {
                        var tmpStyle = season.styles.find((style) => style.stylenumber === id);
                        if (tmpStyle) {
                            tmpStyle = { ...tmpStyle, styleSort: tmpStyle.stylenumber, status: '', assets: [] };
                        }
                        return tmpStyle;
                    })
                    .filter(Boolean); // Remove any undefined styles
                pageStyleSuggestions[pageIdx] = tmpStyleSuggestions;
            });
        }

        // Create a new SeasonDocumentModel instance with the additional pageStyleSuggestions
        const tmpDocument = new SeasonDocumentModel({
            ...document.toJSON(),
            pageStyleSuggestions,
        });
        logger.log('tmpDocument', tmpDocument);
        openModal({
            // title: `${data?.documentName || 'Document Viewer'}`,
            size: '100%',
            fullScreen: true,
            padding: 0,
            withCloseButton: false,
            onClose: () => {
                closeAllModals();
                // remove the documentId from the url
                const newParams = new URLSearchParams(searchParams);
                newParams.delete('documentId');
                setSearchParams(newParams);
            },
            overlayProps: {
                blur: 0,
                opacity: 1,
                color: '#000',
            },
            // styles: {
            //     modal: {
            //         margin: 0,
            //         padding: 0,
            //     },
            //     body: {
            //         padding: 0,
            //         height: '100vh',
            //     },
            //     content: {
            //         height: '100vh',
            //     },
            //     header: {
            //         padding: '8px 16px',
            //         borderBottom: '1px solid #e9ecef',
            //         backgroundColor: '#f8f9fa'
            //     }
            // },
            children: (
                <DocumentViewer
                    aggData={aggData}
                    document={tmpDocument}
                    initialPageIndex={0}
                    onPageChange={handlePageChange}
                    maxHeight='100vh'
                    showMetadata={true}
                    showThumbnails={true}
                    initialLayout='stacked'
                    onClose={() => {
                        closeAllModals();
                        // remove the documentId from the url
                        const newParams = new URLSearchParams(searchParams);
                        newParams.delete('documentId');
                        setSearchParams(newParams);
                    }}
                />
            ),
        });
    };

    const handleDocumentDownload = (document) => {
        logger.log('Download document:', document);
        // TODO: Implement document download functionality
        showNotification({
            title: 'Document Download',
            message: `Downloading ${document.documentName}`,
            color: 'green',
        });
    };

    const handleDocumentEdit = (document) => {
        logger.log('Edit document:', document);
        // TODO: Implement document edit functionality
        showNotification({
            title: 'Document Edit',
            message: `Editing ${document.documentName}`,
            color: 'yellow',
        });
    };

    const handleDocumentDelete = (document) => {
        logger.log('Delete document:', document);
        // TODO: Implement document delete functionality with confirmation
        openConfirmModal({
            title: 'Delete Document',
            children: <Text size='sm'>Are you sure you want to delete "{document.documentName}"? This action cannot be undone.</Text>,
            labels: { confirm: 'Delete', cancel: 'Cancel' },
            confirmProps: { color: 'red' },
            onConfirm: () => {
                // TODO: Implement actual delete logic
                showNotification({
                    title: 'Document Deleted',
                    message: `${document.documentName} has been deleted`,
                    color: 'red',
                });
            },
        });
    };

    const listToggleHandler = (val) => {
        navigate({ search: `?displayType=${val}` });
    };

    return (
        <div style={{ height: '100%' }}>
            <Box
                px='lg'
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    position: 'relative',
                }}>
                <Group className='container-action-bar' sx={{ width: '100%' }} position='apart' height={'100%'} pt='xl' pb={'sm'} mb={'sm'}>
                    <Group>
                        {/* <CheckboxDropdown selectedItems={selectedItems} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} /> */}
                        <Input
                            value={documentFilter.keyword}
                            sx={{ width: 260 }}
                            onChange={(e) =>
                                setDocumentFilter({
                                    ...documentFilter,
                                    keyword: e.currentTarget.value,
                                    pageIndex: 0,
                                })
                            }
                            placeholder={`Search across ${season?.documents?.length ? season.documents.length : ''} Documents`}
                            rightSection={
                                <ActionIcon
                                    onClick={() =>
                                        setDocumentFilter({
                                            ...documentFilter,
                                            keyword: '',
                                        })
                                    }>
                                    {documentFilter.keyword.length ? <IconX size={14} /> : null}
                                </ActionIcon>
                            }
                            icon={<IconSearch />}
                        />

                        <Text size='sm'>
                            Total{' '}
                            <strong>
                                {data?.length} of {season?.documents?.length}
                            </strong>{' '}
                        </Text>

                        {/* <Button
                            onClick={() =>
                                onSampleAction({
                                    type: SeasonActions.ASSIGN_SAMPLE,
                                })
                            }
                            leftIcon={<IconPlus size={14} />}
                            variant={'light'}>
                            Assign
                        </Button> */}
                    </Group>

                    <Group>
                        {/* <Button variant='light' leftIcon={<IconPlus size={AppConstants.ICON_SIZE} stroke={AppConstants.ICON_STROKE_WIDTH} />} onClick={() => setSampleModalOpen(true)}>
                            Create Style
                        </Button> */}

                        <Button variant='light' onClick={() => onAction(DocumentEventType.DOCUMENT_ADD)} leftIcon={<IconPlus size={AppConstants.ICON_SIZE} stroke={AppConstants.ICON_STROKE_WIDTH} />}>
                            Add Document
                        </Button>

                        {/* <Menu shadow='md' width={200}>
                            <Menu.Target>
                                <Button variant='light' leftIcon={<IconPlus size={AppConstants.ICON_SIZE} stroke={AppConstants.ICON_STROKE_WIDTH} />}>
                                    Add Document
                                </Button>
                            </Menu.Target>

                            <Menu.Dropdown>
                                <Menu.Item onClick={() => setSampleModalOpen(true)} icon={<IconPlus size={14} />}>
                                    Create Single Style
                                </Menu.Item>
                                <Menu.Item onClick={() => setSampleImportModalOpen(true)} icon={<IconDatabaseImport size={14} />}>
                                    Import from Masters
                                </Menu.Item>
                            </Menu.Dropdown>
                        </Menu> */}
                        {/* add list and grid view toggle using a segmented control */}
                        {/* <ListToggleControl value={listView} onChange={(val) => listToggleHandler(val)}/> */}

                        <Popover shadow='sm' position='bottom-end' opened={filterOpen} onClose={() => setFilterOpen(false)} width={600} withArrow closeOnClickOutside={true}>
                            <Popover.Target>
                                <div>
                                    <FilterButton onClick={filterButtonHandler} onClear={onClearClick} count={filterCount} />
                                </div>
                            </Popover.Target>

                            <Popover.Dropdown className='filter-panel-dropdown-wrapper'>
                                <Box shadow='xs' style={{ width: '100%' }}>
                                    <FilterPanel
                                        filter={documentFilter}
                                        onCancel={() => setFilterOpen(false)}
                                        onApply={(vals) => {
                                            setFilterVars(vals);
                                            setFilterOpen(false);
                                        }}
                                        filterItems={filterItems}
                                    />
                                </Box>
                            </Popover.Dropdown>
                        </Popover>

                        {/* <ColumnFilterMenu columns={columns} hiddenColumns={hiddenColumns} onChange={(val, data, isShown) => columnFilterHandler(val, data, isShown)} /> */}
                        {/* <Select
                            placeholder='Group By'
                            value={documentFilter.groupBy}
                            onChange={(val) =>
                                setSampleFilter({
                                    ...documentFilter,
                                    groupBy: val,
                                })
                            }
                            data={[
                                { value: '', label: 'No Group' },
                                {
                                    value: 'styleNumber',
                                    label: 'Group by Style',
                                },
                                {
                                    value: 'colourName',
                                    label: 'Group by Colour',
                                },
                            ]}
                        /> */}
                    </Group>
                </Group>

                {/* <ScrollArea style={{height:500}} > */}

                {season && data ? (
                    <Box
                        sx={(theme) => ({ flexGrow: 1, overflow: 'auto', marginRight: -theme.spacing.xl })}
                        className={documentFilter.groupBy && documentFilter.groupBy.length ? 'main-container-content show-data-grouped' : 'main-container-content show-data-grouped-hidden'}>
                        {listView === ListViewOption.LIST ? (
                            <ScrollArea
                                sx={(theme) => ({
                                    // height: '100%',
                                    marginRight: -theme.spacing.xl,
                                    paddingRight: theme.spacing.xl,
                                })}
                                onScrollPositionChange={({ y }) => setScrolled(y !== 0)}>
                                <Table size='sm' {...getTableProps()}>
                                    <thead className={cx('scrollTableHeader', { ['scrolled']: scrolled })}>
                                        {headerGroups.map((headerGroup, hgIdx) => {
                                            const { key, ...hgProps } = headerGroup.getHeaderGroupProps();
                                            return (
                                                <tr key={hgIdx} {...hgProps}>
                                                    {headerGroup.headers.map((column) => {
                                                        const { key, ...colProps } = column.getHeaderProps(column.getSortByToggleProps());

                                                        return (
                                                            // Add the sorting props to control sorting. For this example
                                                            // we can add them into the header props
                                                            <th key={key} {...colProps}>
                                                                <Group position='apart'>
                                                                    <Text size='sm'>{column.render('Header')}</Text>
                                                                    {/* Add a sort direction indicator */}
                                                                    <Group>
                                                                        {column.isSorted ? (
                                                                            column.isSortedDesc ? (
                                                                                <ActionIcon color='brand' size='xs' radius='xl' variant='subtle'>
                                                                                    <IconChevronDown size={16} />
                                                                                </ActionIcon>
                                                                            ) : (
                                                                                <ActionIcon color='brand' size='xs' radius='xl' variant='subtle'>
                                                                                    <IconChevronUp size={16} />
                                                                                </ActionIcon>
                                                                            )
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </Group>
                                                                </Group>
                                                            </th>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </thead>

                                    {isLoading ? (
                                        <tbody>
                                            {[1, 2, 3, 4, 5].map((i) => (
                                                <tr key={i}>
                                                    {columns.map((col, idx) => {
                                                        return (
                                                            <td>
                                                                <Skeleton height={8} my='lg' />
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            ))}
                                        </tbody>
                                    ) : (
                                        <tbody>
                                            {page.map((row, i) => {
                                                prepareRow(row);
                                                const { key, ...rowProps } = row.getRowProps();
                                                return (
                                                    <React.Fragment key={i}>
                                                        {!row.original.documentName ? (
                                                            <tr>
                                                                <td>
                                                                    <Group>
                                                                        <Group sx={{ flexShrink: 0 }}>
                                                                            <Group>
                                                                                <Skeleton height={26} radius='xl' width={26} />
                                                                            </Group>
                                                                            <Box sx={{ flexShrink: 1 }}>
                                                                                <Skeleton height={16} radius='xl' width={200} mb={'xs'} />
                                                                                <Skeleton height={10} radius='xl' width={100} />
                                                                            </Box>
                                                                        </Group>
                                                                    </Group>
                                                                </td>
                                                                <td>
                                                                    <Skeleton height={10} radius='xl' width={'100%'} />
                                                                </td>
                                                                <td>
                                                                    <Skeleton height={10} radius='xl' width={'100%'} />
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr key={key} {...rowProps}>
                                                                {row.cells.map((cell) => {
                                                                    let renderCell;
                                                                    // let checked = selectedItems.find((val) => val.id === row.original.id) ? true : false;
                                                                    let checked = false;
                                                                    switch (cell.column.id) {
                                                                        case 'id': {
                                                                            renderCell = (
                                                                                <Group>
                                                                                    <Group sx={{ flexShrink: 0 }}>
                                                                                        <Group>
                                                                                            <IconPalette />
                                                                                        </Group>
                                                                                        <Box sx={{ flexShrink: 1 }}>
                                                                                            <Anchor size='sm' onClick={() => onDocumentAction(DocumentEventType.DOCUMENT_VIEW, row.original)}>
                                                                                                <Text size='sm' lineClamp={1} sx={{ maxWidth: '250px' }}>
                                                                                                    {row.original.name}
                                                                                                </Text>
                                                                                            </Anchor>
                                                                                            <Text size='xs' color='dimmed'>
                                                                                                {row.original.id}
                                                                                            </Text>
                                                                                        </Box>
                                                                                    </Group>
                                                                                </Group>
                                                                            );
                                                                            break;
                                                                        }
                                                                        case 'action': {
                                                                            renderCell = (
                                                                                <Group
                                                                                    sx={{
                                                                                        width: '100%',
                                                                                        alignContent: 'flex-end',
                                                                                        justifyContent: 'flex-end',
                                                                                    }}>
                                                                                    {/* <GuideItemMenu onMenuItemClick={(e) => onGuideAction(e, row.original)} /> */}
                                                                                    {/* <MediaItemMenu onMenuItemClick={(e) => onMenuClick(e, row.original)} /> */}
                                                                                </Group>
                                                                            );
                                                                            break;
                                                                        }

                                                                        default: {
                                                                            renderCell = (
                                                                                <>
                                                                                    <Text lineClamp={2} size='sm'>
                                                                                        {cell.render('Cell')}
                                                                                    </Text>
                                                                                </>
                                                                            );
                                                                        }
                                                                    }
                                                                    const { key, ...cellProps } = cell.getCellProps();
                                                                    return (
                                                                        <td key={key} {...cellProps} className={checked ? 'cellChecked' : ''}>
                                                                            {renderCell}
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                    )}
                                </Table>

                                {!isLoading && page.length === 0 ? <EmptyState /> : null}
                            </ScrollArea>
                        ) : (
                            <Group sx={{ height: '100%', marginLeft: -20, marginRight: -20 }}>
                                {/* <SessionMediaGridLayout captures={page} selectedItems={selectedItems} onImageEvent={onImageEvent} onCaptureChange={onCaptureChange} /> */}
                            </Group>
                        )}

                        {/* Footer */}
                        <Paper shadow='sm'>
                            <Group className={[classes.displayFooter, 'pagination-footer']} p='sm'>
                                <Pagination size={'sm'} total={pageOptions.length} withEdges page={pageIndex + 1} onChange={(idx) => gotoPage(idx - 1)} />
                                <Group>
                                    <Text size='sm'>
                                        Page{' '}
                                        <strong>
                                            {pageIndex + 1} of {pageOptions.length}
                                        </strong>{' '}
                                    </Text>

                                    <NativeSelect
                                        size='sm'
                                        value={pageSize}
                                        onChange={(e) => {
                                            setPageSize(Number(e.target.value));
                                        }}
                                        data={[
                                            { value: 20, label: 'Show 20' },
                                            { value: 50, label: 'Show 50' },
                                            { value: 80, label: 'Show 80' },
                                            { value: 100, label: 'Show 100' },
                                        ]}></NativeSelect>
                                </Group>
                            </Group>
                        </Paper>

                        {/* {listView === ListViewOption.LIST ? (
                            // <Box sx={(theme) => ({ '.h-scroll-table-container': { paddingRight: theme.spacing.xl }, height: data.length !== 0 ? 'auto' : '100%' })}>
                            <SampleList
                                data={data}
                                onItemClick={onItemClick}
                                onMenuItemClick={onMenuItemClick}
                                onItemSelected={onItemSelected}
                                onStatusClick={onStatusClick}
                                selectedItems={selectedItems}
                                filter={documentFilter}
                                loading={isLoading}
                                actionMenu={rowMenuItems}
                                paginationSize={200}
                                setFilter={setSampleFilter}
                                columns={columns}
                                allowAssignCapture={false}
                                hiddenColumns={hiddenColumns}
                            />
                        ) : (
                            // </Box>
                            <SampleGrid data={data} onItemClick={onItemClick} onItemSelected={onItemSelected} selectedItems={selectedItems} />
                        )} */}
                    </Box>
                ) : null}

                {/* {data && data.length === 0 && !isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: 200,
                        }}>
                        <EmptyState />
                    </Box>
                ) : null} */}

                {/* </ScrollArea> */}

                {/* {filterOpen ? (
                    <Box
                        style={{
                            backgroundColor: '#000',
                            opacity: '0.05',
                            position: 'absolute',
                            top: '155px',
                            right: 0,
                            bottom: 0,
                            left: '0px',
                            zIndex:2
                        }}></Box>
                ) : null} */}

                <Modal withCloseButton={true} size={'lg'} title='Create a new Style' opened={sampleModalOpen} trapFocus={true} onClose={() => setSampleModalOpen(false)}>
                    <SampleEdit
                        createAnotherFlag={displayPrefs.createAnotherStyleFlag}
                        season={season}
                        onCancel={() => setSampleModalOpen(false)}
                        onSampleSave={() => onSampleSave()}
                        onPrefChange={(val) => onPrefChange(val)}
                    />
                </Modal>

                <Modal withCloseButton={true} size={'90%'} title='Import Styles from Masters' opened={sampleImportModalOpen} trapFocus={true} onClose={() => setSampleImportModalOpen(false)}>
                    <MastersStyleImport
                        createAnotherFlag={displayPrefs.createAnotherStyleFlag}
                        season={season}
                        onCancel={() => setSampleModalOpen(false)}
                        onAction={(action, data) => onMastersImport(action, data)}
                        onPrefChange={(val) => onPrefChange(val)}
                    />
                </Modal>

                <Modal withCloseButton={true} size={'lg'} title='Batch Upload Samples' opened={sampleUploadShown} trapFocus={true} onClose={() => setSampleUploadShown(false)}>
                    <SamplesUpload />
                </Modal>
            </Box>
        </div>
    );
};

// const FilterPanel = ({ onCancel, onApply, filter, filterItems }) => {
//     logger.log(filter);
//     const form = useForm({
//         initialValues: {
//             ...filter,
//             otbDate: {
//                 dateStart: filter.otbDate?.dateStart?.toString().length ? moment(filter.otbDate?.dateStart).toDate() : '',
//                 dateEnd: filter.otbDate?.dateEnd?.toString().length ? moment(filter.otbDate?.dateEnd).toDate() : '',
//             },
//         },
//     });

//     logger.log(form.values);

//     // logger.log(filter, filterItems, form.values);
//     // useEffect(() => {
//     //     if (filter && form) {
//     //         form.setValues({ ...filter });
//     //     }
//     // }, [filter, form]);

//     const getFilterVars = useCallback(
//         (key) => {
//             var res = [];
//             if (filterItems[key]) Object.keys(filterItems[key]).forEach((val) => res.push(val));
//             return res.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
//         },
//         [filter, filterItems],
//     );

//     const onSegmentChange = (e) => {
//         logger.log(e);
//     };

//     return (
//         <Box shadow='xs' style={{ width: '100%' }}>
//             <form onSubmit={form.onSubmit((values) => onApply(values))}>
//                 <Box pr={'md'} style={{ height: 400, overflow: 'auto', marginRight: -15 }}>
//                     <FormInputWrapper label='Photo Code' labelWidth={'120px'}>
//                         <MultiSelect data={getFilterVars('photoCode')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('photoCode')} />
//                     </FormInputWrapper>
//                     <FormInputWrapper label='Sample Size' labelWidth={'120px'}>
//                         <MultiSelect data={getFilterVars('sampleSize')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('sampleSize')} />
//                     </FormInputWrapper>
//                     <FormInputWrapper label='Style' labelWidth={'120px'}>
//                         <MultiSelect data={getFilterVars('shotStyle')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('shotStyle')} />
//                     </FormInputWrapper>
//                     <FormInputWrapper label='Department' labelWidth={'120px'}>
//                         <MultiSelect data={getFilterVars('department')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('departments')} />
//                     </FormInputWrapper>
//                     {/* <FormInputWrapper label='Sessions' labelWidth={'120px'}>
//                     <MultiSelect
//                         data={getFilterVars('sessions')}
//                         label=''
//                         placeholder='Pick all that you like'
//                         searchable
//                         nothingFound='Nothing found'
//                         {...form.getInputProps('sessions')}
//                     />
//                 </FormInputWrapper> */}
//                     {/* <FormInputWrapper label='Status' id='input-brands' labelWidth={'120px'}>
//                     <Stack>
//                         <Checkbox label='Sample Acquired' {...form.getInputProps('status.sampleCount', { type: 'checkbox' })} />
//                         <Checkbox label='Has Photography' {...form.getInputProps('status.photographyCount', { type: 'checkbox' })} />
//                         <Checkbox label='Has Tasks' {...form.getInputProps('status.taskCount', { type: 'checkbox' })} />
//                         <Checkbox label='Tasks Completed' {...form.getInputProps('status.completedTaskCount', { type: 'checkbox' })} />
//                     </Stack>

//                 </FormInputWrapper> */}
//                     <FormInputWrapper label='OTB Date' id='input-shootdate' labelWidth={'120px'}>
//                         <Group noWrap>
//                             <CustomDatePicker sx={{ width: 190 }} placeholder='From OTB Date' {...form.getInputProps('otbDate.dateStart')} />
//                             <Text>to</Text>
//                             <CustomDatePicker sx={{ width: 190 }} placeholder='To OTB Date' {...form.getInputProps('otbDate.dateEnd')} />
//                         </Group>
//                     </FormInputWrapper>

//                     <Divider />
//                     <FormInputWrapper label='Has Session' labelWidth={'120px'}>
//                         <Box sx={{ width: '100%' }}>
//                             <SegmentedControl
//                                 sx={{ flexShrink: 0 }}
//                                 data={[
//                                     { label: 'All', value: '' },
//                                     { label: 'Yes', value: '1' },
//                                     { label: 'No', value: '0' },
//                                 ]}
//                                 placeholder='Has Session'
//                                 onChange={(e) => onSegmentChange(e)}
//                                 {...form.getInputProps('status.hasSession')}
//                             />

//                             {form.values.status.hasSession === '1' ? (
//                                 <MultiSelect
//                                     mt={'sm'}
//                                     sx={{ flexGrow: `1 !important` }}
//                                     data={getFilterVars('sessions')}
//                                     label=''
//                                     placeholder='Pick all that you like'
//                                     searchable
//                                     nothingFound='Nothing found'
//                                     {...form.getInputProps('sessions')}
//                                 />
//                             ) : null}
//                         </Box>
//                     </FormInputWrapper>
//                     <Divider />
//                     <FormInputWrapper label='Multi Shot' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Has Photography'
//                             {...form.getInputProps('multiShotFlag')}
//                         />
//                     </FormInputWrapper>
//                     <FormInputWrapper label='Sample Acquired' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Sample Acquired'
//                             {...form.getInputProps('status.sampleCount')}
//                         />
//                     </FormInputWrapper>

//                     <FormInputWrapper label='Has Photography' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Has Photography'
//                             {...form.getInputProps('status.photographyCount')}
//                         />
//                     </FormInputWrapper>

//                     <FormInputWrapper label='Has Tasks' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Has Tasks'
//                             {...form.getInputProps('status.taskCount')}
//                         />
//                     </FormInputWrapper>

//                     <FormInputWrapper label='Tasks Complete' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Tasks Complete'
//                             {...form.getInputProps('status.taskCompleteCount')}
//                         />
//                     </FormInputWrapper>

//                     {/* <FormInputWrapper label='Brands' id='input-brands' labelWidth={'120px'}>
//                     <MultiSelect data={getFilterVars('brands')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('brands')} />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Category' id='input-category' labelWidth={'120px'}>
//                     <MultiSelect data={getFilterVars('categories')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('categories')} />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Department' id='input-department' labelWidth={'120px'}>
//                     <MultiSelect
//                         data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
//                         label=''
//                         placeholder='Pick all that you like'
//                         searchable
//                         nothingFound='Nothing found'
//                         {...form.getInputProps('department')}
//                     />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Location' id='input-location' labelWidth={'120px'}>
//                     <MultiSelect
//                         data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
//                         label=''
//                         placeholder='Pick all that you like'
//                         searchable
//                         nothingFound='Nothing found'
//                         {...form.getInputProps('location')}
//                     />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Status' id='input-status' labelWidth={'120px'}>
//                     <MultiSelect
//                         data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
//                         label=''
//                         placeholder='Pick all that you like'
//                         searchable
//                         nothingFound='Nothing found'
//                         {...form.getInputProps('status')}
//                     />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Colour' id='input-colour' labelWidth={'120px'}>
//                     <ColorInput placeholder='Pick color' {...form.getInputProps('colour')} />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Assigned Product' id='input-colour' labelWidth={'120px'}>
//                     <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Part of a Season' id='input-assigned-product' labelWidth={'120px'}>
//                     <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Part of an Outfit' id='input-assigned-season' labelWidth={'120px'}>
//                     <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
//                 </FormInputWrapper> */}
//                 </Box>
//                 <Divider />
//                 <Group position='apart' mt='sm'>
//                     <Button variant='subtle' component='button' size='sm' onClick={() => onCancel()}>
//                         Cancel
//                     </Button>
//                     <Button type='submit' size='sm'>
//                         Apply
//                     </Button>
//                 </Group>
//             </form>
//         </Box>
//     );
// };

const mapStateToProps = (state, props) => {
    logger.log(state, props);
    return {
        user: state.auth.user,
        aggData: state.appReducer.aggData,
        season: state.seasonReducer.selectedSeason,
        selectedSamples: state.seasonReducer.selectedSamples,
        success: state.seasonReducer.success,
        documentFilters: state.seasonReducer.seasonDocumentFilters,
        displayPrefs: state.seasonReducer.displayPrefs,
        // documentFilter: state.warehouse.documentFilter,
        error: state.auth.error,
    };
};

const mapDispatchToProps = {
    selectSamples: selectSamples,
    setDocumentFilters: setSeasonDocumentFilters,
    setDisplayPrefs: setDisplayPrefs,
};

export default connect(mapStateToProps, mapDispatchToProps)(SeasonTabDocuments);

const FilterPanel = ({ onCancel, onApply, filter, filterItems }) => {
    logger.log(filter);

    const form = useForm({
        initialValues: {
            ...filter,
        },
    });

    // useEffect(() => {
    //     if (filter && form) {
    //         form.setValues({ ...filter });
    //     }

    //     logger.log(form.values);
    // }, [filter, form]);

    const getFilterVars = (key) => {
        var res = [];
        if (filterItems[key]) Object.keys(filterItems[key]).forEach((val) => res.push(val));
        return res;
    };

    const onSegmentChange = (e) => {
        logger.log(e);
    };

    return (
        <Box shadow='xs' style={{ width: '100%' }}>
            <form onSubmit={form.onSubmit((values) => onApply(values))}>
                <ScrollArea.Autosize mah={SETTINGS.FILTER_PANEL_MAX_HEIGHT_LG} className='filter-scroll-content'>
                    <FormInputWrapper label='Page Count' id='input-totalPages' labelWidth={'130px'}>
                        <Group noWrap>
                            <NumberInput sx={{ width: 190 }} placeholder='From' {...form.getInputProps('pageRange.pageStart')} />
                            <Text>to</Text>
                            <NumberInput sx={{ width: 190 }} placeholder='To' {...form.getInputProps('pageRange.pageEnd')} />
                        </Group>
                    </FormInputWrapper>

                    <FormInputWrapper label='Has Products' labelWidth={'130px'}>
                        <Box sx={{ width: '100%' }}>
                            <SegmentedControl
                                sx={{ flexShrink: 0 }}
                                data={[
                                    { label: 'All', value: '' },
                                    { label: 'Yes', value: '1' },
                                    { label: 'No', value: '0' },
                                ]}
                                placeholder='Has Products'
                                onChange={(e) => onSegmentChange(e)}
                                {...form.getInputProps('hasProducts')}
                            />
                        </Box>
                    </FormInputWrapper>
                </ScrollArea.Autosize>
                <Group position='apart' mt='md' className='action-bar'>
                    <Button variant='default' size='sm' onClick={() => onCancel()}>
                        Cancel
                    </Button>
                    <Button type='submit' size='sm'>
                        Apply
                    </Button>
                </Group>
            </form>
        </Box>
    );
};
